import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import classNames from 'classnames';

import debounce from 'rebook/apps/utils/debounce';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import * as SearchQueryActions from 'rebook/apps/search/actions/SearchQueryActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import SearchResultsCount from 'rebook/apps/search/components/SearchResultsCount';
import SearchResultEmpty from 'rebook/apps/search/components/SearchResultEmpty';
import SearchBookList from 'rebook/apps/search/components/SearchBookList';
import SearchAudioBookList from 'rebook/apps/search/components/SearchAudioBookList';
import SearchAuthorList from 'rebook/apps/search/components/SearchAuthorList';
import SearchSeriesList from 'rebook/apps/search/components/SearchSeriesList';
import SearchGenresThemesList from 'rebook/apps/search/components/SearchGenresThemesList';
import SearchBooksetList from 'rebook/apps/search/components/SearchBooksetList';
import SearchRightholdersList from 'rebook/apps/search/components/SearchRightholdersList';

import styles from './style.scss';


const debouncedFetch = debounce(fetchQuery, 250);

const SearchLoader = () => (
  <div className={styles.searchLoader}>
    <SpinnerLoader />
  </div>
);

class SearchResultView extends React.Component {
  constructor(props) {
    super(props);

    this.paginateBy = 20;

    this.state = {
      isLoading: true,
      query: this.props.history.location.search,
      bookList: [],
      authorsList: [],
      seriesList: [],
      booksetList: [],
      genresList: [],
      nichesList: [],
      tagsList: [],
      rightholdersList: [],
      booksCount: 0,
      authorsCount: 0,
      seriesCount: 0,
      booksetsCount: 0,
      genresCount: 0,
      nichesCount: 0,
      tagsCount: 0,
      rightholdersCount: 0,
    };
  }

  componentDidMount() {
    const { searchQuery, history, SearchQueryActions } = this.props;

    if (!searchQuery.value) {
      SearchQueryActions.initQuery(history);
    }

    this.handleSearchQuery(searchQuery.value);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchQuery.value !== this.props.searchQuery.value) {
      this.handleSearchQuery(nextProps.searchQuery.value);
    }
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      title: `Результаты поиска по электронной библиотеке MyBook. ` +
      `Читать более ${this.props.booksPerSubscriptionCounter.total} книг по подписке на iPhone, iPad, Android`,
    });
  }

  componentWillUnmount() {
    this.props.SearchQueryActions.cancelQuery();
    this.props.SeoActions.resetData();
  }

  handleSearchQuery(query) {
    let value;

    if (query) {
      value = query.trim();
    }

    if (!value || value.length < 3) {
      return;
    }

    this.setState({
      isLoading: true,
    }, () => this.updateSearchResults(value)
    );
  }

  updateSearchResults(query) {
    this.setState({ query });

    let queryParams = {
      q: query,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/?${qs}`;

    ga('send', 'event', 'Search', 'SendQuery');

    debouncedFetch(url, { apiVersion: 5 })
      .then(({ data }) => {
        if (this.state.isLoading) {
          this.props.SearchQueryActions.setLoadingStatus(false);
        }
        const genresList = data.genres.slice(0, 5);
        const nichesList = data.niches.slice(0, 5);
        const tagsList = data.tags.slice(0, 5);
        const genresThemesCount = genresList.length + nichesList.length + tagsList.length;
        this.setState({
          bookList: data.books,
          audioBookList: data.audiobooks,
          authorsList: data.authors,
          seriesList: data.series,
          booksetList: data.booksets,
          genresList,
          nichesList,
          tagsList,
          rightholdersList: data.rightholders,
          genresThemesCount,
          booksCount: data.books_count,
          audioBooksCount: data.audiobooks_count,
          authorsCount: data.authors_count,
          seriesCount: data.series_count,
          booksetsCount: data.booksets_count,
          rightholdersCount: data.rightholders_count,
          isLoading: false,
        });
      });
  }

  render() {
    const {
      isLoading, bookList, booksCount, authorsCount, authorsList, seriesCount, seriesList,
      booksetsCount, booksetList, genresList, nichesList, tagsList, genresThemesCount, query,
      audioBookList, audioBooksCount, rightholdersList, rightholdersCount,
    } = this.state;

    const totalCount = booksCount + authorsCount + seriesCount + genresThemesCount + booksetsCount;

    return isLoading && query
      ? (
        <div className="backgroundContainer themeGrey">
          <SearchLoader />
        </div>
      )
      : totalCount > 0
        ? (
          <div className={classNames('backgroundContainer', 'themeGrey', styles.searchResults)}>
            <div className={styles.searchResultsContent}>
              <SearchResultsCount
                bookList={bookList}
                booksCount={booksCount}
                audioBookList={audioBookList}
                audioBooksCount={audioBooksCount}
                authorsCount={authorsCount}
                authorsList={authorsList}
                seriesList={seriesList}
                seriesCount={seriesCount}
                booksetList={booksetList}
                booksetsCount={booksetsCount}
                nichesList={nichesList}
                genresList={genresList}
                tagsList={tagsList}
                genresThemesCount={genresThemesCount}
                rightholdersList={rightholdersList}
                rightholdersCount={rightholdersCount}
                totalCount={totalCount}
                query={query} />
              {booksCount > 0 && (
                <SearchBookList bookList={bookList} booksCount={booksCount} query={query} />
              )}
              {audioBooksCount > 0 && (
                <SearchAudioBookList audioBookList={audioBookList} audioBooksCount={audioBooksCount} query={query} />
              )}
              {authorsCount > 0 && (
                <SearchAuthorList authorsList={authorsList} authorsCount={authorsCount} query={query} />
              )}
              {seriesCount > 0 && (
                <SearchSeriesList seriesList={seriesList} seriesCount={seriesCount} query={query} />
              )}
              {genresThemesCount > 0 && (
                <SearchGenresThemesList
                  nichesList={nichesList}
                  genresList={genresList}
                  tagsList={tagsList}
                  genresThemesCount={genresThemesCount}
                  query={query} />
              )}
              {booksetsCount > 0 && (
                <SearchBooksetList booksetList={booksetList} booksetsCount={booksetsCount} query={query} />
              )}
              {rightholdersCount > 0 && (
                <SearchRightholdersList
                  rightholdersList={rightholdersList}
                  rightholdersCount={rightholdersCount}
                  query={query} />
              )}
            </div>
          </div>
        )
        : <SearchResultEmpty />;
  };
}

function mapStateToProps(state) {
  return {
    searchQuery: state.searchQuery,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchQueryActions: bindActionCreators(SearchQueryActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultView);
